import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { FORM_MSGS, ADMIN_UTILITY } from 'src/app/_common/product-config';
import { LoginService } from '../_services/login.service';
import { CustomUserStatus } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-activate-user',
  templateUrl: './activate-user.component.html',
  styleUrls: ['./activate-user.component.scss']
})
export class ActivateUserComponent implements OnInit {
  @ViewChild("activationForm", {static: false}) activationForm: NgForm;
  @ViewChild("internalServerErrorModal", {static: false}) InternalServerErrorModalComponent;
  
  private uid;
  private loading: boolean = false;
  private userActivationLoading: boolean = false;
  private submitted:boolean = false;
  private dataResult: any;
  private formMsgs = FORM_MSGS;
  private emailID: string = '';
  private userStatus: string = '';
  private firstName: string = '';
  private lastName: string = '';
  private enumUserStatus: any;
  private activationError: any;
  private passwordContainsName: boolean = false;

  constructor(private readonly route: ActivatedRoute, private router: Router, private loginService: LoginService) { }

  ngOnInit() {    
    this.route.paramMap.subscribe(params => {
      this.uid =  params.get("id").toString();
    });
    this.enumUserStatus = CustomUserStatus;
    this.validatePendingUser();
  }

  validatePendingUser () {
    this.loading = true;
    this.loginService.validatePendingUser(this.uid).subscribe(data => {
      this.loading = false;
      this.dataResult = data.body.result;
      this.activationError = data.body.errorContent.message;
      
      if(this.dataResult === null) {
        if(this.activationError === this.enumUserStatus.NotFound || this.activationError === this.enumUserStatus.InvalidUser) {
          this.router.navigate(['/login'], {state: {warningMessage: ADMIN_UTILITY.UserAccountNotFound}});
        }
      } else {
        this.userStatus = this.dataResult.statusDesc;
        if(this.userStatus === this.enumUserStatus.PendingActivation) {
          this.firstName = this.dataResult.firstName;
          this.lastName = this.dataResult.lastName;
          this.emailID = this.dataResult.emailID;
        }
        else if(this.userStatus === this.enumUserStatus.Active) {
          this.router.navigate(['/login'], {state: {warningMessage: ADMIN_UTILITY.UserAccountActivated_Login}});
        } else if(this.userStatus === this.enumUserStatus.Deactivated){
          this.router.navigate(['/login'], {state: {warningMessage: ADMIN_UTILITY.UserAccountDeactivated}});
        } else if(this.userStatus === this.enumUserStatus.Expired){
          this.router.navigate(['/login'], {state: {warningMessage: ADMIN_UTILITY.UserAccountExpired}});
        }
      }     
    }, error => {
      this.loading = false;
      this.router.navigateByUrl("/login", {replaceUrl: true});
    });
  }

  onActivation() {
    if(this.activationForm.valid) {
      this.userActivationLoading = true;
      this.loginService.activateUser(this.uid, this.activationForm['newPassword']).subscribe(data => {
        this.userActivationLoading = false;
        this.router.navigate(['/login'], {state: {successMessage: ADMIN_UTILITY.UserAccountActivatedSuccessfully}});
      },
      error => {
        if(error.error.errorContent.message == this.formMsgs.PasswordContainsName){
          this.passwordContainsName = true;
        }
        else{
          this.loginService.openModal("error", this.InternalServerErrorModalComponent);
        }
        this.userActivationLoading = false;
      });
    }
  }
}